import {Button, TableProps} from "antd";
import React from "react";
import {BasicTable} from "../../Common/BasicComponents/BasicTable";
import {AdminHttpService} from "../../../services/Http/SearchTableService";
import {FilterString} from "../../Common/BasicComponents/filters/FilterString";
import {InsuranceProviderEclaim} from "../../../models/InsuranceProvider";
import {PlusCircleOutlined} from "@ant-design/icons";
import {AuthService} from "../../../services/AuthService";
import {useModal} from "../../../utils/modals";
import {BasicFormMethod, BasicFormModal} from "../../Common/BasicComponents/BasicFormModal";
import {PageTitle} from "../../Common/PageTitle/PageTitle";

export interface InsuranceProviderManagementPageProps {

}

export type AnyObject = Record<string, any>; // A common definition for a generic object

export function InsuranceProviderManagementPage<T extends AnyObject>(props:InsuranceProviderManagementPageProps) {
    const {
        isOpen: isCreateFormModalOpen,
        open: openCreateFormModal,
        close: closeCreateFormModal
    } = useModal();

    const columns: TableProps<InsuranceProviderEclaim>['columns'] = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Codice',
            dataIndex: 'code',
            key: 'code'
        },
        {
            title: 'Descrizione',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Codice di Integrazione',
            dataIndex: 'integrationCode',
            key: 'integrationCode'
        }
    ]

    const searchFilters =[
        <FilterString dataKey={"code"} placeholder={"Codice"}></FilterString>,
        <FilterString dataKey={"description"} placeholder={"Descrizione"}></FilterString>,
        // <FilterString dataKey={"integrationCode"} placeholder={"Codice di Integrazione"}></FilterString>
    ]

    const formInputFields =[
        <FilterString dataKey={"code"} label={"Codice"} forceUpperCase={true}  required={true}></FilterString>,
        <FilterString dataKey={"description"} label={"Descrizione"} forceUpperCase={true}  required={true}></FilterString>,
        <FilterString dataKey={"integrationCode"} label={"Codice di Integrazione"} forceUpperCase={true}  required={true}></FilterString>
    ]

    return <>
        <PageTitle title={"Gestione Assicurazioni"}></PageTitle>
        <BasicTable<InsuranceProviderEclaim>
            columns={columns}
            urlPath={AdminHttpService.URL_ADMIN_INSURANCE_PROVIDERS}
            filters={searchFilters}
        />

        <Button icon={<PlusCircleOutlined/>} type={"primary"} key="download"
                style={{float: 'right', marginTop: '10px', marginLeft: '10px'}}
                onClick={() => {
                    AuthService.isAdmin() && openCreateFormModal()
                }}>
            Aggiungi assicurazione
        </Button>

        {isCreateFormModalOpen &&
            <BasicFormModal<InsuranceProviderEclaim> urlPath={AdminHttpService.URL_ADMIN_INSURANCE_PROVIDERS} method={BasicFormMethod.CREATE}
                            isOpen={isCreateFormModalOpen} onOk={closeCreateFormModal} onCancel={closeCreateFormModal}
                            inputFields={formInputFields} title={"Aggiungi assicurazione"} ></BasicFormModal>}
    </>

}